import { render, staticRenderFns } from "./testnav.vue?vue&type=template&id=35a2bb4c&scoped=true"
import script from "./testnav.vue?vue&type=script&lang=js"
export * from "./testnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2bb4c",
  null
  
)

export default component.exports